const mEditionBillingArtificialIntelligence = {
  mEditionBillingArtificialIntelligence: {
    // Una pestaña por modalidad: la clave es la misma "modalidad" que devuelve el core-api en cada plan
    tabs: {
      mensual: 'Planes mensuales',
      creditos: 'Paquetes de créditos'
    },

    quote: {
      mensual: 'Creá los planes mensuales de Inteligencia Artificial que se van a poder incluir en un producto: el cliente tiene los créditos del plan todos los meses y lo consumido vuelve a 0 el día en que paga.',
      creditos: 'Creá los paquetes de créditos de Inteligencia Artificial que se van a poder incluir en un producto: se pagan una sola vez, no vencen y no se renuevan.',
      secondText: 'Los créditos se fijan al crearlo y no se editan después: si necesitás otra cantidad, creá otro y desactivá el anterior.'
    },

    buttonPrimary: {
      mensual: 'CREAR PLAN MENSUAL',
      creditos: 'CREAR PAQUETE DE CRÉDITOS'
    },

    empty: {
      mensual: 'Todavía no hay planes mensuales creados.',
      creditos: 'Todavía no hay paquetes de créditos creados.',
      action: 'Creá el primero con el botón de arriba.'
    },

    card: {
      detail: 'Ver detalle',
      activo: 'Publicado',
      inactivo: 'No publicado',

      // {creditos} llega ya formateado con separador de miles
      creditos: {
        mensual: '{creditos} créditos por mes',
        creditos: '{creditos} créditos, pago único'
      },

      actions: {
        activar: 'Activar',
        desactivar: 'Desactivar',
        eliminar: 'Eliminar'
      }
    },

    modal: {
      title: {
        mensual: 'CREAR PLAN MENSUAL',
        creditos: 'CREAR PAQUETE DE CRÉDITOS'
      },

      fields: {
        titulo: 'Título',
        tituloPlaceholder: {
          mensual: 'Ej: IA 5.000',
          creditos: 'Ej: 10.000 créditos'
        },
        creditos: {
          mensual: 'Créditos por mes',
          creditos: 'Créditos del paquete'
        },
        creditosPlaceholder: 'Ej: 5000',
        imagen: 'Imagen',
        imagenButton: 'Elegir imagen'
      },

      hint: 'Los créditos no se editan después: si necesitás otra cantidad, creá otro y desactivá el anterior. Se crea sin publicar, así lo revisás antes de activarlo desde el detalle.',

      buttons: {
        cancel: 'CANCELAR',
        submit: 'CREAR'
      },

      errors: {
        titulo: 'El título es obligatorio (entre 3 y 120 caracteres)',
        creditos: 'Los créditos tienen que ser un número entero mayor que 0'
      }
    },

    alerts: {
      readSatelites: {
        error: 'No se pudieron cargar los planes de Inteligencia Artificial.'
      },

      createSatelite: {
        error: 'No se pudo crear el plan de Inteligencia Artificial.',
        success: 'Plan de Inteligencia Artificial creado.'
      },

      updateSatelite: {
        error: 'No se pudo actualizar el plan de Inteligencia Artificial.',
        success: 'Plan de Inteligencia Artificial actualizado.'
      },

      uploadImagen: {
        error: 'El plan se creó, pero no se pudo subir la imagen.'
      },

      imagenExtension: {
        error: 'El archivo tiene que ser una imagen.'
      },

      imagenSize: {
        error: 'La imagen supera el tamaño permitido.'
      },

      deleteSatelite: {
        error: 'No se pudo eliminar el plan de Inteligencia Artificial.',
        success: 'Plan de Inteligencia Artificial eliminado.'
      }
    },

    modalDetail: {
      caracteristicas: 'Características',
      close: 'Cerrar',

      modalidad: {
        label: 'Modalidad',
        mensual: 'Plan mensual',
        creditos: 'Paquete de créditos'
      },

      creditos: {
        label: 'Créditos',
        mensual: '{creditos} por mes',
        creditos: '{creditos}'
      },

      renovacion: {
        label: 'Renovación',
        mensual: 'Cada mes, el día en que paga el cliente',
        creditos: 'No se renueva ni vence'
      }
    },

    modalDelete: {
      title: {
        mensual: 'ELIMINAR PLAN MENSUAL',
        creditos: 'ELIMINAR PAQUETE DE CRÉDITOS'
      },
      text: 'Se eliminará',
      warning: 'Los productos que lo tengan incluido dejarán de ofrecerlo. Las licencias ya vendidas no se ven afectadas: conservan sus créditos.',
      buttons: {
        cancel: 'CANCELAR',
        submit: 'ELIMINAR'
      }
    }
  }
}

export default mEditionBillingArtificialIntelligence
